import { ChapterTabList, ChapterTools, type ChapterTabsProps } from './ChapterTabs';

/**
 * Feature 023 — the Study tab rail (design: `.toc`).
 *
 * A cream column of chapter tabs with the all-chapters tools pinned below them. Shown beside both
 * the Study landing page and the chapter reader, so the whole book is one click away from anywhere
 * in the Study. `study.css` hides it on phones and in the landscape-phone band; `ChapterPicker`
 * carries the same content there.
 */
export function StudySidebar(props: ChapterTabsProps) {
  return (
    <div className="study-toc">
      <nav aria-label="Chapters">
        <h2 className="px-[22px] pb-2.5 text-xs font-semibold uppercase tracking-[1.6px] text-ink-soft">
          The notes
        </h2>
        <ChapterTabList {...props} />
      </nav>

      {/*
        The drawer. `mt-auto` pins it to the foot of a rail taller than its content; `sticky
        bottom-0` keeps it on screen when the rail is SHORTER than its content and scrolls
        internally — a laptop or landscape tablet has no room for eight 44px tabs plus three tools,
        and without this the drawer sat below the fold of a scroller with no visible bar on touch,
        which read as "the tools are missing". The rail's own bottom padding moved onto this block
        (see study.css) so the stuck drawer meets the rail's bottom edge.
      */}
      <div className="sticky bottom-0 mt-auto border-t border-line bg-cream pb-[22px] pt-3">
        <h2 className="px-[22px] pb-1.5 text-xs font-semibold uppercase tracking-[1.6px] text-ink-soft">
          All chapters
        </h2>
        <ChapterTools />
      </div>
    </div>
  );
}
